/**
 * Returns a human-readable error message.
 * If `e` is an Error the `.message` property is used; otherwise `fallback` is returned.
 *
 * @param e - The caught unknown value
 * @param fallback - String shown when e is not an Error instance
 */
export function formatError(e: unknown, fallback: string): string {
  return e instanceof Error ? e.message : fallback;
}
